(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["veloura-cuotas"] && !Shopify.designMode) return;
  try {
    (function () {
    var CLAVE = 'veloura:cuotas';

    function leer() {
      try { return window.localStorage.getItem(CLAVE); } catch (e) { return null; }
    }
    function guardar(v) {
      try { window.localStorage.setItem(CLAVE, v); } catch (e) { /* sin persistencia */ }
    }

    function pintar(caja, plan) {
      caja.querySelectorAll('[data-vcuo-plan]').forEach(function (el) {
        el.hidden = el.getAttribute('data-vcuo-plan') !== plan;
      });
      caja.querySelectorAll('input[type=radio]').forEach(function (r) {
        r.checked = r.value === plan;
      });
    }

    // Aplica la preferencia guardada a todas las cajas presentes. Se llama al
    // cargar y de nuevo cuando Horizon re-renderiza la seccion por cambio de
    // variante, porque ahi vuelve el HTML con el plan "a" por defecto.
    function aplicar() {
      var plan = leer();
      if (plan !== 'a' && plan !== 'b') return;
      document.querySelectorAll('[data-vcuo]').forEach(function (caja) {
        pintar(caja, plan);
      });
    }

    document.addEventListener('change', function (e) {
      var radio = e.target.closest('[data-vcuo] input[type=radio]');
      if (!radio) return;
      var caja = radio.closest('[data-vcuo]');
      pintar(caja, radio.value);
      guardar(radio.value);
      // Si hay mas de una ficha en pantalla (quick add abierto), que coincidan.
      document.querySelectorAll('[data-vcuo]').forEach(function (otra) {
        if (otra !== caja) pintar(otra, radio.value);
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', aplicar);
    } else {
      aplicar();
    }
    document.addEventListener('shopify:section:load', aplicar);
    // Horizon avisa el cambio de variante con este evento.
    document.addEventListener('variant:update', aplicar);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["veloura-envio"] && !Shopify.designMode) return;
  try {
    (function () {
    var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio',
                 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

    function repartEse(dow, sabado) {
      if (dow === 0) return false;
      if (dow === 6) return sabado;
      return true;
    }

    // Primer dia de reparto valido DESPUES de "desde".
    function siguienteHabil(desde, sabado) {
      var d = new Date(desde);
      for (var i = 0; i < 14; i++) {
        d.setDate(d.getDate() + 1);
        if (repartEse(d.getDay(), sabado)) return d;
      }
      return d;
    }

    function rangoEnPalabras(a, b) {
      if (a.getMonth() === b.getMonth()) {
        return a.getDate() + ' y ' + b.getDate() + ' de ' + MESES[b.getMonth()];
      }
      return a.getDate() + ' de ' + MESES[a.getMonth()] +
             ' y ' + b.getDate() + ' de ' + MESES[b.getMonth()];
    }

    function dos(n) { return n < 10 ? '0' + n : '' + n; }

    function refrescar(caja) {
      var corte = parseInt(caja.dataset.corte, 10);
      var sabado = caja.dataset.sabado === 'true';
      var ahora = new Date();

      var aTiempo = ahora.getHours() < corte && repartEse(ahora.getDay(), sabado);

      // La entrega cae entre el proximo dia de reparto y el que le sigue.
      var min = siguienteHabil(ahora, sabado);
      var max = siguienteHabil(min, sabado);

      var elFecha = caja.querySelector('[data-venv-fecha]');
      if (elFecha) elFecha.textContent = rangoEnPalabras(min, max);

      var reloj = caja.querySelector('[data-venv-reloj]');
      if (!reloj) return;
      if (!aTiempo) { reloj.hidden = true; return; }

      var limite = new Date(ahora);
      limite.setHours(corte, 0, 0, 0);
      var resta = Math.max(0, Math.floor((limite - ahora) / 1000));
      var h = Math.floor(resta / 3600);
      var m = Math.floor((resta % 3600) / 60);
      var s = resta % 60;
      reloj.hidden = false;
      var num = reloj.querySelector('[data-venv-num]');
      if (num) num.textContent = h > 0 ? h + ':' + dos(m) + ':' + dos(s) : dos(m) + ':' + dos(s);
    }

    var timer = null;

    function tick() {
      var cajas = document.querySelectorAll('[data-venv]');
      if (!cajas.length) return;
      cajas.forEach(refrescar);
    }

    function arrancar() {
      tick();
      if (timer) window.clearInterval(timer);
      // Cada segundo solo porque el contador muestra segundos.
      timer = window.setInterval(tick, 1000);
    }

    function parar() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    // Con la pestaña de fondo no hay nadie mirando el contador.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) parar(); else arrancar();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', arrancar);
    } else {
      arrancar();
    }
    document.addEventListener('shopify:section:load', tick);
  })();
  } catch(e) { console.error(e); }
})();

})();
